import e from "./ghl-ui.es755.js";
import a from "./ghl-ui.es756.js";
import o from "./ghl-ui.es757.js";
import i from "./ghl-ui.es758.js";
import n from "./ghl-ui.es759.js";
import S from "./ghl-ui.es760.js";
import t from "./ghl-ui.es761.js";
var g = "[object Map]", T = "[object Object]", f = "[object Promise]", u = "[object Set]", w = "[object WeakMap]", b = "[object DataView]", j = t(e), C = t(a), M = t(o), d = t(i), v = t(n), r = S;
(e && r(new e(new ArrayBuffer(1))) != b || a && r(new a()) != g || o && r(o.resolve()) != f || i && r(new i()) != u || n && r(new n()) != w) && (r = function(c) {
  var m = S(c), p = m == T ? c.constructor : void 0, s = p ? t(p) : "";
  if (s)
    switch (s) {
      case j:
        return b;
      case C:
        return g;
      case M:
        return f;
      case d:
        return u;
      case v:
        return w;
    }
  return m;
});
const h = r;
export {
  h as default
};
